export default __webpack_public_path__ + "static/media/twitterTheme-girl.837494e0.svg";